import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { UtilService } from './services/util/util.service';
import { CompanyStorageService } from '../app/core/company/company.storage';
import { ApiService } from './services/api.service';
import { MaintenanceService } from './core/maintenance/maintenance.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  menU: any = 1;
  subMenu: any = 0;
  activeSubMenu: any = null;
  sideMenu = true;
  goGreenRedirecting = false;


  appPages = [
    {
      title: 'Dashboard',
      url: '/home',
      icon: 'grid',
      position: 'top',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Leads',
      url: '/leads',
      icon: 'film',
      position: 'top',
      imagebefore: 'icon-leads-blue.svg',
      imageafter: 'icon-leads.svg',
    },
    {
      title: 'Prospect',
      url: '/funding',
      icon: 'settings',
      position: 'top',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Partner',
      url: '',
      icon: 'film',
      position: 'top',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Marketplace',
      url: '',
      icon: 'film',
      position: 'top',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'User',
      url: '/user',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Setting',
      url: '/setting',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Logout',
      url: '/logout',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
  ];

  appPagesBottom = [
    {
      title: 'User',
      url: '/user',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Setting',
      url: '/setting',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
    {
      title: 'Logout',
      url: '/logout',
      icon: 'film',
      position: 'bottom',
      imagebefore: 'icon-dashboard-blue.svg',
      imageafter: 'icon-dashboard.svg',
    },
  ];
  // public appPages = [
  //   { title: 'Inbox', url: '/folder/Inbox', icon: 'mail' },
  //   { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
  //   { title: 'Favorites', url: '/folder/Favorites', icon: 'heart' },
  //   { title: 'Archived', url: '/folder/Archived', icon: 'archive' },
  //   { title: 'Trash', url: '/folder/Trash', icon: 'trash' },
  //   { title: 'Spam', url: '/folder/Spam', icon: 'warning' },
  // ];
  // public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  usertoken: any;
  user: any;

  menu: any;

  hasilSlug: any;
  companytoken: string;

  constructor(
    public router: Router,
    public util: UtilService,
    public api: ApiService,
    private companyStorage: CompanyStorageService,
    private maintenance: MaintenanceService,
    private menuCtrl: MenuController
  ) {
    this.usertoken = localStorage.getItem('usertoken') || '';
    this.companytoken = this.companyStorage.getVerifyToken();

    this.maintenance.state$.subscribe(s => {
      if (s.active && this.router.url !== '/error-maintenance') {
        this.router.navigate(['/error-maintenance']);
      }
    });

    // console.log('ut',this.usertoken);
    if (this.usertoken && this.companytoken) {
      if (this.router.url !== '/error-maintenance') {
        this.router.navigateByUrl('/home');
      }
      this.user = JSON.parse(localStorage.getItem('user') || '');
      // console.log('user', this.user);
      this.menu = this.user.access_menu;
    } else {
      if (this.router.url !== '/error-maintenance') {
        this.router.navigateByUrl('/login');
      }
    }
    // this.router.navigateByUrl('');
  }

  fungsilogout() {
    this.util.showToast('Anda Berhasil Keluar', 'success', 'bottom');
    localStorage.removeItem('usertoken');
    window.location.href = '/login';
  }

  selectedIndex(nama: any) {
    if (String(nama).trim() === 'Go Green') {
      this.openGoGreen();
      return;
    }

    const url = this.generateSlug(nama);
    console.log(url);
    if (this.menU === '') {
      this.menU = nama;
    } else if (this.menU === nama) {
      this.menU = '';
    } else {
      this.menU = nama;
    }
    this.menuCtrl.close('main-menu');
    this.router.navigate([url]);
  }

  openGoGreen() {
    if (this.goGreenRedirecting) {
      return;
    }

    this.goGreenRedirecting = true;
    this.util.show('Sedang mengalihkan ke Go Green...', 'loading-white-spinner');

    this.api.get('backoffice/gogreen/url')
      .subscribe((data: any) => {
        this.goGreenRedirecting = false;
        this.util.hide();

        const url = data?.data?.url;
        if (url) {
          window.open(url, '_blank');
          return;
        }
        this.util.showToast(data?.message || 'URL Go Green tidak tersedia', 'danger', 'bottom');
      }, (error) => {
        this.goGreenRedirecting = false;
        this.util.hide();

        console.log('error', error);
        this.api.errorCond(error);
      });
  }


  generateSlug(inputText: any) {
    const filteredText = inputText.replace(/[^a-zA-Z0-9\s]/g, '');
    const textWithoutSpaces = filteredText.replace(/\s+/g, '-');
    const lowercaseText = '/' + textWithoutSpaces.toLowerCase();
    return lowercaseText;
    // console.log(lowercaseText)
  }

  buka(item: any) {
    if (this.activeSubMenu === item) {
      this.activeSubMenu = null;
      this.subMenu = 0;
      return;
    }
    this.activeSubMenu = item;
    this.subMenu = item?.seq ?? item?.menu_id;
    this.sideMenu = true;
  }

  minimize() {
    if (this.sideMenu === true) {
      this.sideMenu = false;
      this.subMenu = 0;
      this.activeSubMenu = null;
    } else {
      this.sideMenu = true;
    }
  }

}
